import { projectDeliveryRejectedKey } from 'root/src/shared/constants/keys'

import { REJECT_DELIVERY } from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'
import { REVIEW_DELIVERY } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { PENDING_DELIVERIES_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[REJECT_DELIVERY]: {
		endpointId: REVIEW_DELIVERY,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['audit', projectDeliveryRejectedKey],
		],
		validation: [{ prop: 'message', type: 'required' }],
		label: 'Reject dare',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectDeliveryRejectedKey,
			},
		],
		onSuccessRedirect: { routeId: PENDING_DELIVERIES_ROUTE_ID },
	},
}
